module.exports = __webpack_public_path__ + "df228858.svg";